export const DATE_FORMAT = {
    MONTH_YEAR: 'MMMM YYYY',
    MONTH_NAME: 'MMMM',
    DAY_MONTH: 'DD. MMM',
    YEAR: 'YYYY',
    DAY_MONTH_YEAR: 'DD. MMM YYYY',
    DAY_MONTH_YEAR_TIME: 'DD. MMM YYYY, HH:mm',
    DATE_MONTH_YEAR: 'DD.MM.YYYY',
    DAY_NAME_MONTH_NAME_DAY_YEAR: 'ddd DD. MMM YYYY',
    FULL_DATE_TIME: 'ddd DD. MMM YYYY HH:mm:ss',
    BASIC_DATA_YEAR: 'DD/MM/YYYY',
    SERVER_DATE: 'YYYY-MM-DD'
};
